import { useMemo } from 'react'

import { CanvasConfig, CanvasConfigV2 } from '@editor/interfaces/editor'
import { PlaneSide } from '@editor/interfaces/shape'
import { Mode } from '@editor/pages/projects/blueprint-editor/definitions'
import { useAppSelector } from '@editor/store/app'

const useObjects = (
  polyline: CanvasConfig,
  planeDetection: CanvasConfig,
  volumeEstimation: CanvasConfig,
): CanvasConfigV2 => {
  // Store
  const checkedEditorElements = useAppSelector((state) => state.blueprint.drawings.document.editorElements)
  const mode = useAppSelector((state) => state.blueprint.editor.mode)

  return useMemo(
    () => ({
      objects: {
        labels: [],
        polylines: [
          ...(polyline.objects?.polylines || []).filter(({ id }) =>
            checkedEditorElements.inspectionItems.some((item) => item.id === id),
          ),
        ],
        polygonPlaneMeshesV2: [
          ...(planeDetection.objects?.polygonPlaneMeshesV2 || []).filter(({ id }) =>
            checkedEditorElements.polygons.some((item) => item.id === id),
          ),
          ...(volumeEstimation.objects?.polygonPlaneMeshesV2 || []).filter(
            ({ id, polygon }) =>
              checkedEditorElements.inspectionItems.some((item) => item.id === id) &&
              // Hide bottom planes in 2D blueprint view
              !(mode === Mode.Editor2D && polygon.plane_side === PlaneSide.LOWER),
          ),
        ],
      },
    }),
    [checkedEditorElements, mode, polyline, planeDetection, volumeEstimation],
  )
}

export default useObjects
